import ROUTES from '../routes';
import Blacklist from '../hoc/blacklist/blacklist';
import BlacklistList from '../hoc/blacklist/list';
import BlacklistUsers from '../hoc/blacklist/users';
import BlacklistWrapper from '../hoc/blacklist/list-wrapper';
import BlacklistUserInfo from '../hoc/blacklist/user';
import BlacklistCreate from '../hoc/blacklist/create';
import BlacklistPage from '../hoc/blacklist/item';
import BlacklistPageSettings from '../hoc/blacklist/item-settings';
import BlacklistAddRecord from '../hoc/blacklist/add-record';
import BlacklistChangeLogs from '../hoc/blacklist/change-logs';

const BlacklistRoutes = {
  path: ROUTES.BLACKLIST,
  element: <Blacklist />,
  children: [
    {
      path: ROUTES.BLACKLIST_LIST,
      element: <BlacklistWrapper />,
      children: [
        {
          path: ROUTES.BLACKLIST_LIST_RESULTS,
          element: <BlacklistList />,
          children: [
            {
              path: ROUTES.BLACKLIST_LIST_CREATE,
              element: <BlacklistCreate type="results" />,
            },
          ],
        },
        {
          path: ROUTES.BLACKLIST_LIST_USERS,
          element: <BlacklistUsers />,
          children: [
            {
              path: ROUTES.BLACKLIST_USERS_CREATE,
              element: <BlacklistCreate type="users" />,
            },
            {
              path: ROUTES.BLACKLIST_USER,
              element: <BlacklistUserInfo blacklist={false} />,
            },
          ],
        },
      ],
    },
    {
      path: ROUTES.BLACKLIST_ITEM,
      element: <BlacklistPage />,
      children: [
        {
          path: ROUTES.BLACKLIST_ITEM_SETTINGS,
          element: <BlacklistPageSettings />,
        },
        {
          path: ROUTES.BLACKLIST_ITEM_CHANGE_LOG,
          element: <BlacklistChangeLogs />,
        },
        {
          path: ROUTES.BLACKLIST_ITEM_ADD_RECORD,
          element: <BlacklistAddRecord />,
        },
        {
          path: ROUTES.BLACKLIST_ITEM_EDIT_RECORD,
          element: <BlacklistAddRecord />,
        },
        {
          path: ROUTES.BLACKLIST_ITEM_USER_INFO,
          element: <BlacklistUserInfo blacklist />,
        },
      ],
    },
  ],
};

export default BlacklistRoutes;
